import Component from "vue-class-component";
import router from "./router";
import { AppBase } from "./../CharginStations/AppBase";

@Component({
  router,
})
export default class App extends AppBase {
  protected mapBoxApiKey = "pk.eyJ1IjoiMjRuZXQiLCJhIjoiY204b3ZwOGFwMDRlZTJpcXh1MjlzZGIxZiJ9.-ElHASjNijmKsRDa5990bg";
  protected googleApiKey = "AIzaSyCSyk_jutz-52JjU_3d99vfStlKhpswCT8";
  protected sourceUrl = "https://fdrive.cz/data/export/pub/charging-stations-geo.json";

  protected mounted() {
    this.mounted();
  }

  protected fitCountryInView() {
    super.fitCountryInView();
  }
}
